// .u_accordion
class UAccordion extends Uneet {
  constructor(domElement) {
    super(domElement)
    this.__init()
  }

  __init() {
    const itemsDOM = Array.from(this._e.querySelectorAll('.item'))
    const currentOpen = this.current || 1
    jQuery(itemsDOM).find('.content').hide()
    jQuery(itemsDOM[currentOpen - 1]).addClass('isOpen').find('.content').slideDown('fast')

    itemsDOM.forEach((item) => {
      item.querySelector('.title').addEventListener('click', (e) => {
        const clickedItem = jQuery(e.target).parent()
        if (clickedItem.hasClass('isOpen')) {
          clickedItem.removeClass('isOpen').find('.content')
            .slideUp('fast')
        } else {
          jQuery(itemsDOM).removeClass('isOpen').find('.content').slideUp('fast')
          clickedItem.addClass('isOpen').find('.content')
            .slideDown('fast')
        }
      })
    })
  }
}
